<template>
    <b-row class="justify-content-center text-center">
        <b-col cols="12" md="8">
            <h1 class="mb-3">
                {{ $t('preventa.iniciar_sesion_para_registrarse') }}
            </h1>
            <p class="mb-4 text-muted">
                {{ $t('preventa.poder_registrarse') }}
                <strong>{{ teatro.nombre }}</strong>.
                {{ $t('preventa.iniciar_sesion_o_registrarse') }}
            </p>
            <div class="d-flex justify-content-center gap-3 flex-wrap">
                <router-link 
                    to="/login?preventa" 
                    :class="['button', 'effect-button', 'mr-md-2 mb-2 mb-md-0', { 'large-button': !esMovil, 'w-100': esMovil }]"
                >
                    <span>
                        {{ $t('preventa.iniciar_sesion') }}
                    </span>
                </router-link>
                <router-link 
                    to="/register?preventa" 
                    :class="['button', 'effect-button', { 'large-button': !esMovil, 'w-100': esMovil }]"
                >
                    <span>
                        {{ $t('preventa.crear_cuenta') }}
                    </span>
                </router-link>
            </div>
        </b-col>
    </b-row>
</template>

<script setup>
    import { computed } from 'vue';
    import { useVersionMovil } from '@/composables/common/useVersionMovil'
    import store from '@/store'; 

    const { esMovil } = useVersionMovil()

    const teatro = computed(() => {
        return store.getters.getTeatro;
    });
</script>